import { render, staticRenderFns } from "./hot_spot_type_detial.vue?vue&type=template&id=35759f30&scoped=true"
import script from "./hot_spot_type_detial.vue?vue&type=script&lang=js"
export * from "./hot_spot_type_detial.vue?vue&type=script&lang=js"
import style0 from "./hot_spot_type_detial.vue?vue&type=style&index=0&id=35759f30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35759f30",
  null
  
)

export default component.exports